import { Link } from "react-router-dom";
import { channels } from "@/mocks/channels";

export default function NotFound() {
  return (
    <div className="container-page flex min-h-[70vh] flex-col items-center justify-center py-20 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-md bg-primary-100 text-primary-700">
        <i className="ri-search-eye-line text-2xl" aria-hidden="true" />
      </span>
      <h1 className="mt-6 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
        这一页档案暂时找不到
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        链接可能已经调整，或者内容正在重新归档。你可以返回首页，或从下面的栏目继续阅读。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" aria-hidden="true" />
          返回首页
        </Link>
        <Link
          to="/channels"
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          浏览栏目
        </Link>
      </div>
      <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
        {channels.map((c) => (
          <Link
            key={c.slug}
            to={`/channel/${c.slug}`}
            className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-100 px-3.5 py-1.5 text-xs text-foreground-600 transition-colors hover:bg-background-200"
          >
            <i className={c.icon} aria-hidden="true" />
            {c.name}
          </Link>
        ))}
      </div>
    </div>
  );
}